(function () {
  var country = window.__mbn_country;
  var code    = window.__mbn_country_code;
  if (!country || code === 'GB') return;

  // Adjectival demonyms for "X Buyers" — falls back to country name if not mapped
  var DEMONYMS = {
    'US': 'American',      'CA': 'Canadian',      'AU': 'Australian',    'NZ': 'New Zealand',
    'IE': 'Irish',         'ZA': 'South African', 'SG': 'Singaporean',   'IN': 'Indian',
    'DE': 'German',        'FR': 'French',        'IT': 'Italian',       'ES': 'Spanish',
    'PT': 'Portuguese',    'NL': 'Dutch',         'BE': 'Belgian',       'SE': 'Swedish',
    'NO': 'Norwegian',     'DK': 'Danish',        'FI': 'Finnish',       'AT': 'Austrian',
    'CH': 'Swiss',         'PL': 'Polish',        'CZ': 'Czech',         'HU': 'Hungarian',
    'BR': 'Brazilian',     'MX': 'Mexican',       'AR': 'Argentine',     'CL': 'Chilean',
    'CO': 'Colombian',     'PE': 'Peruvian',      'JP': 'Japanese',      'KR': 'Korean',
    'CN': 'Chinese',       'HK': 'Hong Kong',     'TW': 'Taiwanese',     'TH': 'Thai',
    'MY': 'Malaysian',     'PH': 'Filipino',      'ID': 'Indonesian',    'VN': 'Vietnamese',
    'AE': 'Emirati',       'IL': 'Israeli',       'SA': 'Saudi',         'QA': 'Qatari',
    'GR': 'Greek',         'RO': 'Romanian',      'HR': 'Croatian',      'TR': 'Turkish',
    'RU': 'Russian',       'UA': 'Ukrainian',     'EG': 'Egyptian',      'NG': 'Nigerian',
    'KE': 'Kenyan',        'GH': 'Ghanaian',      'MA': 'Moroccan',
    'LT': 'Lithuanian',    'LV': 'Latvian',       'EE': 'Estonian',      'SK': 'Slovak',
    'BG': 'Bulgarian',     'RS': 'Serbian'
  };

  var demonym = DEMONYMS[code] || country;

  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/;

  function replaceInNode(node) {
    if (node.nodeType === 3) {
      var v = node.nodeValue;
      if (v.indexOf('UK') === -1) return;
      // "UK Buyers" → demonym form first, then remaining "UK" → country name
      v = v.replace(/\bUK\b(?=\s+Buyers)/g, demonym);
      v = v.replace(/\bUK\b/g, country);
      node.nodeValue = v;
    } else if (node.nodeType === 1 && !SKIP.test(node.nodeName)) {
      for (var i = 0; i < node.childNodes.length; i++) replaceInNode(node.childNodes[i]);
    }
  }

  function run() { if (document.body) replaceInNode(document.body); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var obs = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) { replaceInNode(n); });
    });
  });

  function startObs() {
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObs);
  } else {
    startObs();
  }
})();
